import { useBillingRepository } from '@Hooks/useRepository';
import { InvoicesRepository } from '@Repositories/Billing';
import { type Result } from '@synqo/frontend-component-library';
import { useMutation } from '@tanstack/react-query';
import type { ApiInvoice } from '@Model';

interface UseCashPayment {
    startPayment: (id: string) => Promise<Result<ApiInvoice[]>>;
    isPending: boolean;
}

export function useCashPayment(type: 'order' | 'invoice'): UseCashPayment {
    const invoices = useBillingRepository(InvoicesRepository);

    const { mutateAsync: cashPaymentMutation, isPending } = useMutation({
        mutationFn: (id: string) =>
            type === 'order' ? invoices.startOrderCashPayment(id) : invoices.startInvoiceCashPayment(id),
    });

    return {
        startPayment: cashPaymentMutation,
        isPending,
    };
}
